import Page from './page';

const selectors = {
  section: '.js-documentStorageSection',
};

export default class DocumentStoragePage extends Page {

  constructor(private body: HTMLBodyElement) {
    super();
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('section')) {
      DocumentStoragePage.clearUnreadDocumentNotification(urlParams.get('section') as string);
    }

    this.bindClearUnreadNotifications();
  }

  private bindClearUnreadNotifications() {
    this.body.querySelectorAll(selectors.section).forEach((section) => {
      section.addEventListener('click', (event) => {
        const sectionId = (event.currentTarget as HTMLElement).id;
        DocumentStoragePage.clearUnreadDocumentNotification(sectionId);
      });
    });
  }

  private static clearUnreadDocumentNotification(sectionId: string) {
    fetch(`/documentStorageSection/seen/${sectionId}`, {
      method: 'GET',
    }).then(() => { /* do nothing */ })
      .catch(() => { /* do nothing */ });
  }

}
